import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getAvailableAggregateCards(options = {}) {
	return _apiRequestWrap(
		ModulesMap.AGGREGATE_CARDS,
		ModulesConfigMap[ModulesMap.AGGREGATE_CARDS].GET_AVAILABLE_AGGREGATE_CARDS,
		options
	)
}

export default {
	getAvailableAggregateCards: _getAvailableAggregateCards,
}